import {
  ACTIONS_TEXT,
  IMAGE_SRC,
} from 'src/app/components/shared/shared-constants';
import { Items } from 'src/app/core/models/common/items.model';
import { CreateDeliveryResponse } from 'src/app/core/models/operations/operations-delivery.model';
import { CreatePickupResponse } from 'src/app/core/models/operations/operations-pickup-stop.model';
import { RouteDetailsResponse } from 'src/app/core/models/operations/operations-route-details.model';

export const ROUTE_DETAILS_CONSTANTS = {
  SUMMARY: $localize`Summary`,
  ROUTE_DETAILS: $localize`Route Details`,
  ROUTE_SUMMARY: $localize`Route Summary`,
  OPERATIONS: $localize`Operations`,
  COMMERCIAL: $localize`Commercial`,
  RESENDENTIAL: $localize`Residential`,
  DETAILS: $localize`Detail(s)`,
  PENDING_STOPS: $localize`Pending Stops`,
  ROUTE: $localize`Route`,
  UNKNOWN: $localize`Unknown`,
};

export enum ColumnIds {
  ID = 'id',
  TYPE = 'type',
  DENSITY = 'density',
  COSIGNEE = 'cosignee',
  ADDRESS = 'address',
  CITY = 'city',
  POSTAL = 'postal',
  COMPLETION_TIME = 'completiontime',
  TRACKING_NUMBER = 'trackingnumber',
  COMMIT_TIME = 'committime',
  ETA = 'eta',
  SCAN_CODE = 'scancode',
  DESCRIPTION = 'description',
  ACTIONS = 'actions',
}

export const ColumnText = {
  STOP_NUMBER: $localize`Stop#`.toUpperCase(),
  TYPE: $localize`Stop Type`.toUpperCase(),
  DENSITY: $localize`Density`.toUpperCase(),
  CONSIGNEE: $localize`Consignee`.toUpperCase(),
  STREET_ADDRESS: $localize`Street Address`.toUpperCase(),
  CITY: $localize`City`.toUpperCase(),
  POSTAL: $localize`Postal Code`.toUpperCase(),
  COMPLETE_TIME: $localize`Complete Time`.toUpperCase(),
  TRACKING_NUMBER: $localize`Tracking Number`.toUpperCase(),
  COMMIT: $localize`Commit`.toUpperCase(),
  ETA: $localize`ETA`.toUpperCase(),
  SCAN_CODE: $localize`Scan Code`.toUpperCase(),
  DESCRIPTION: $localize`Description`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export const STOP_TYPES: Items[] = [
  { id: 'onDemand', src: IMAGE_SRC.PHONE, selected: true },
  { id: 'scheduled', src: IMAGE_SRC.PICKUP, selected: true },
  { id: 'delivery', src: IMAGE_SRC.DELIVERY, selected: true },
];

export const MOCK_DETAILS_DATA: RouteDetailsResponse = {
  response: {
    scan: [
      {
        id: 1,
        type: 'PS',
        state: 'Pending', //Pending or Final
        density: 'C', //Commercial
        planseq: 12,
        cosignee: 'Johnson Pharmaceutical',
        address: '45 Fearsbear road',
        city: 'Scranton',
        postal: '02121',
        completiontime: '',
        stopDate: '',
        packagedetails: [
          {
            trackingnumber: '1Z134243124124',
            committime: '12:00', //24 hour time. Is this from HEAT/GIO/ODIN? where to get this information?
            eta: '12:00', //24 hour time. Is this from HEAT/GIO/ODIN? where to get this information?
            scancode: 'Sig Obtained',
            remark: 'test',
            amtdue: '234.32',
            amtcollected: '12.42',
            shippernumber: 'f321sf',
          },
        ],
        streetparsed: {
          prefix: 'ST', //New
          name: 'Testing', //New
          suffix: 'Dr', //New
          type: 'IDK', //New
          number: '12', //New
        },
      },
      {
        id: 11,
        type: 'PS',
        state: 'Pending', //Pending or Final
        density: 'R', //Residential
        planseq: 13,
        cosignee: '',
        address: '',
        city: '',
        postal: '',
        completiontime: '',
        stopDate: '',
        packagedetails: [
          {
            trackingnumber: '1Z134246124124',
            committime: '12:00', //24 hour time
            eta: '12:00', //24 hour time
            scancode: 'Sig Obtained',
            description: 'test',
            amtdue: '234.32',
            amtcollected: '12.42',
            shippernumber: 'f321sf',
          },
        ],
        streetparsed: {
          prefix: 'ST',
          name: 'Testing',
          suffix: 'Dr',
          type: 'IDK',
          number: '12',
        },
      },
    ],
  },
} as RouteDetailsResponse;

export const SCAN_CODE_OPTIONS: Items[] = [
  { id: 'NqN', selected: true },
  { id: 'N!N', selected: true },
];

export const DENSITY_OPTIONS: Items[] = [
  { id: ROUTE_DETAILS_CONSTANTS.COMMERCIAL, selected: true },
  { id: ROUTE_DETAILS_CONSTANTS.RESENDENTIAL, selected: true },
];

export const EXCEL_FILE_NAME: string = $localize`route-details-data`;

export const deliveryServiceResponse: CreateDeliveryResponse = {
  code: 200,
  status: 'success',
  message: 'Stop processed',
  deviceStatus: 'Active',
  response: {
    summary: {
      txId: '9aed1963-5646-4046-b8d9-de4154fabc6b',
      received: 1,
      accepted: 1,
      rejected: 0,
    },
    stopId: 1168201200,
  },
};

export const pickupServiceResponse: CreatePickupResponse = {
  code: 200,
  status: 'success',
  message: 'Stop processed',
  deviceStatus: 'Active',
  response: {
    summary: {
      txId: '9aed1963-5646-4046-b8d9-de4154fabc6b',
      received: 1,
      accepted: 1,
      rejected: 0,
    },
    stopId: 1168201200,
  },
};

export type RouteDataType = { selectedDate: string };
